"use client";

import { Paragraph, Title } from "@/components/ui/typography";
import Image from "next/image";
import leftbg from "@/public/left-bg.svg";
import rightbg from "@/public/right-bg.svg";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import Animate from "@/components/Animate";

export default function Header() {
  const router = useRouter();

  return (
    <div className="bg-system-obsidian relative h-[500px] ">
      <Image src={rightbg} alt="" className="absolute h-full right-0" />

      <div className=" flex h-full  items-center justify-center ">
        <div className="text-center">
          <Animate animateIn="fadeInUp">
            <Title size="xxl" className="text-system-disabled mb-4">
              <span className="block md:inline-block lg:inline-block">
                Oops!
              </span>{" "}
              Page Not Found
            </Title>
          </Animate>
          <Animate animateIn="fadeInUp" delay={0.4}>
            <Paragraph className="text-system-disabled mb-8">
              Sorry, but the page you are looking for doesn't exist.
            </Paragraph>
          </Animate>
          <Animate animateIn="fadeInUp" delay={0.6}>
            <Button
              size="xl"
              type="link"
              className="w-[150px]"
              onClick={() => router.push("/")}
            >
              Go to Homepage
            </Button>
          </Animate>
        </div>
      </div>
      <Image src={leftbg} alt="" className="absolute top-0 h-full" />
    </div>
  );
}
